module.exports = __webpack_public_path__ + "static/media/impiantoPurple.45294d18.png";